module.exports = __webpack_public_path__ + "img/automotive.629c329f.gif";